import { HttpService } from './http-service';
import { MailWizz } from '@/models/mailwizz/mailwizz';

export class MailWizzService extends HttpService {
    protected getResourceUrl() { return 'api/mailwizzes' };
    protected getResponseMapper() { return MailWizz.parseJson }
}

export const mailWizzService = new MailWizzService();
